
define('app/dashboard/leagues/create/views/lgCreateView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/collections/leagueInstanceCollection',
	'known/collections/productCollection',
	
	//Shims
	'jquery.uniform'
], function($, _, Backbone, UserModel, LeagueInstanceCollection, ProductCollection){
	var Event = _.extend({}, Backbone.Events);
	
	var CreateLeagueInstanceModel = Backbone.Model.extend({
		defaults: {
			id: null,
			displayName: null,
			userName: null,
			prodId: null,
			draftType: null,
			numRounds: null,
			numTeams: null,
			auctionBudget: null
	    },
	    
	    urlRoot: function() {
			return '/draftapp/leagues/';
		},

		initialize: function() {
			
	    }
	});

	var CreateLeagueFooterView = Backbone.View.extend({
		events: {
			'click #crtLgFormSubmit': 'submitLeagueInstanceForm'
		},
		
		initialize: function(options) {
			this.listenTo(Event, 'defaultCreate', this.showLeagueInstanceForm);
			this.listenTo(Event, 'savingLgInst', this.hideAll);
			this.listenTo(Event, 'errorLgInst', this.showLeagueInstanceForm);
			this.listenTo(Event, 'success', this.hideAll);
		},
		
		hideAll: function () {
			this.$("#crtLgSubmitFooter").hide();
		},
		
		submitLeagueInstanceForm: function () {
			Event.trigger("saveLgInst");
		},
		
		showLeagueInstanceForm: function () {
			this.hideAll();
			this.$("#crtLgSubmitFooter").show();
		},
	});

	var CreateLeagueContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.prodCollection = options.prodCollection;
			this.crtLgModel = options.crtLgModel;
			this.userModel = options.userModel;
			this.prodConfigMap = options.prodConfigMap;
			
			this.prodInputContainer = this.$("#crtLgInstProdInputContainer");
			this.prodTemplate = _.template($('#crtLgInstProdInputTemplate').html().trim());
			
			_.bindAll(this, 'checkUpgradeOptions');
			_.bindAll(this, 'displayBudget');
			
			this.listenTo(Event, 'defaultCreate', this.leagueInstanceFormInitial);
			this.listenTo(Event, 'saveLgInst', this.submitLeagueInstance);
			this.listenTo(Event, 'savingLgInst', this.processing);
			this.listenTo(Event, 'errorLgInst', this.leagueInstanceForm);
			this.listenTo(Event, 'success', this.success);
			
			//Error handling
			this.listenTo(Event, 'errorLgInst:drafttype', this.errorType);
			this.listenTo(Event, 'errorLgInst:prodid', this.errorProduct);
			this.listenTo(Event, 'errorLgInst:numteams', this.errorNumTeams);
			this.listenTo(Event, 'errorLgInst:numrounds', this.errorNumRounds);
			this.listenTo(Event, 'errorLgInst:auctionbudget', this.errorBudget);
			
			this.$('input[type=radio][name=lgType]').on("change", this.displayBudget);
		},
		
		submitLeagueInstance: function () {
			Event.trigger("savingLgInst");
			
			var budget = 200;
			var submit = true;
			
			if(this.$('input[name=lgType]:checked').val() == 'AUCTION'){
				budget = this.$('#crtLgInstBudgetInput').val();
				
				if(!budget || budget == ""){
					Event.trigger("errorLgInst");
					Event.trigger("errorLgInst:auctionbudget", "NULL");
					submit = false;
				} else if(budget == "0" || budget == "00" || budget == "000"){
					Event.trigger("errorLgInst");
					Event.trigger("errorLgInst:auctionbudget", "LENGTH");
					submit = false;
				}				
			}
			
			if(submit){
				this.crtLgModel.set("userName", this.userModel.get('userName'), {silent: true});
				this.crtLgModel.set("prodId", this.$('input[name=lgProd]:checked').val(), {silent: true});
				this.crtLgModel.set("draftType", this.$('input[name=lgType]:checked').val(), {silent: true});
				this.crtLgModel.set("numRounds", this.$('#crtLgInstRoundsSelInput').val(), {silent: true});
				this.crtLgModel.set("numTeams", this.$('#crtLgInstTeamsSelInput').val(), {silent: true});
				this.crtLgModel.set("auctionBudget", budget, {silent: true});
				this.crtLgModel.save();
			}
		},
		
		hideAll: function() {
			this.$("#crtLgInstBodyContentForm").hide();
			this.$("#crtLgBodyContentProcessing").hide();
			this.$("#crtLgBodyContentSuccess").hide();
			
			//Hide error messages			
			this.$("#crtLgInstProdGrp").removeClass("error");
			this.$("#crtLgInstProdErrMsg").hide();
			
			this.$("#crtLgInstTypeGrp").removeClass("error");
			this.$("#crtLgInstTypeErrMsg").hide();
			
			this.$("#crtLgInstTeamsSelGrp").removeClass("error");
			this.$("#crtLgInstTeamsSelErrMsg").hide();
			
			this.$("#crtLgInstRoundsSelGrp").removeClass("error");
			this.$("#crtLgInstRoundsSelErrMsg").hide();
			
			this.$("#crtLgInstBudgetGrp").removeClass("error");
			this.$("#crtLgInstBudgetErrMsg").hide();
		},
		
		success: function () {
			this.hideAll();
			
			var link = '/draftapp/dashboard/leagues/' + this.crtLgModel.get('leagueId')+ '/instances/' + this.crtLgModel.get('id');
			
			this.$("#crtLgBodyContentSuccessLink").attr("href", link);
			this.$("#crtLgBodyContentSuccessLink").html(this.crtLgModel.get('displayName'));
			
			this.$("#crtLgBodyContentSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			this.$("#crtLgBodyContentProcessing").show();
		},
		
		leagueInstanceForm: function () {
			this.hideAll();
			this.$("#crtLgInstBodyContentForm").show();
		},
		
		leagueInstanceFormInitial: function () {
			this.populateProdOptions();
			this.checkUpgradeOptions();
			this.leagueInstanceForm();
		},
		
		populateProdOptions: function () {
			var usableProds = this.prodCollection.activeUsableProducts();
			this.prodInputContainer.empty();
			
			this.prodChecked = false;
			
			_.each(usableProds, function(product){
				var usableProducts = product.activeUsableProducts();
				
				this.trialStandard = null;
				this.trialPremium = null;
				this.standard = null;
				this.premium = null;
				this.basic = null;
				
				_.each(usableProducts, function(productType){
					if(productType.get('prodName') == 'BASIC'){
						this.basic = productType;
					} else if(productType.get('prodName') == 'STANDARD'){
						this.standard = productType;
					} else if(productType.get('prodName') == 'PREMIUM'){
						this.premium = productType;
					} else if(productType.get('prodName') == 'TRIALSTD'){
						this.trialStandard = productType;
					} else if(productType.get('prodName') == 'TRIALPRM'){
						this.trialPremium = productType;
					}
				}, this);
				
				
				var desc = product.get('sport') + " " + product.get('year');
				var showTrialStd = false;
				var showTrialPrem = false;
				var checkCurProd = !this.prodChecked;
				this.prodChecked = true;
				
				//Disable nfl until it's released
				//if(product.get('sport').toUpperCase() == 'NFL' && !$(document).getUrlParam('earlyNfl')){
				//	return;
				//}
				
				if(this.premium){
					this.addProdOption(this.prodInputContainer, this.premium, desc + " " + this.premium.prettyProdDesc(), checkCurProd);
				} else if(this.standard){
					showTrialPrem = true;
					this.addProdOption(this.prodInputContainer, this.standard, desc + " " + this.standard.prettyProdDesc(), checkCurProd);					
				} else if(this.basic){
					showTrialPrem = true;
					showTrialStd = true;
					this.addProdOption(this.prodInputContainer, this.basic, desc + " " + this.basic.prettyProdDesc(), checkCurProd);
				}
				
				if(this.trialPremium && showTrialPrem){
					this.addProdOption(this.prodInputContainer,this.trialPremium,"Trial of "+desc+" Premium &mdash; Limited to 2 rounds", false);
				}
				if(this.trialStandard && showTrialStd){
					this.addProdOption(this.prodInputContainer,this.trialStandard,"Trial of "+desc+" Standard &mdash; Limited to 2 rounds", false);
				}
				
				delete this.trialStandard;
				delete this.trialPremium;
				delete this.standard;
				delete this.premium;
				delete this.basic;
			}, this);
			
			delete this.prodChecked;
			this.prodInputContainer.find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});
			this.$('input[type=radio][name=lgProd]').on("change", this.checkUpgradeOptions);
		},
		
		checkUpgradeOptions: function() {
			var selectedProdValue = this.$('input[name=lgProd]:checked').val();
			var custOrderAllowed = false;
			var auctionAllowed = false;
			
			if (selectedProdValue){
				var prod = this.prodCollection.retrieveProdWithProdTypeId(selectedProdValue);
				
				if(prod && prod.get("productTypes").get(selectedProdValue)){
					var prodType = prod.get("productTypes").get(selectedProdValue).get('prodName'); 
					var prodConfig = this.prodConfigMap[prodType];
					
					if(prodConfig){
						custOrderAllowed = prodConfig.CUSTORDER == 'true';
						auctionAllowed = prodConfig.AUCTION == 'true';
					}
				}
			}
			
			if(custOrderAllowed){
				this.$("#crtLgInstTypeCustomRadioLabel").html('Custom Order');		
				this.$("#crtLgInstTypeCustom").removeProp('disabled');
				this.$("#crtLgInstTypeCustomRadio").removeClass('disabled');
			} else {
				if(this.$('input[name=lgType]:checked').val() == 'CUSTOM'){
					this.$('input[name=lgType]').prop('checked', false);
				}
				
				this.$("#crtLgInstTypeCustomRadioLabel").html('Custom Order (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
				this.$("#crtLgInstTypeCustom").prop('disabled', 'disabled');
				this.$("#crtLgInstTypeCustomRadio").addClass('disabled');
			}
			
			if(auctionAllowed){
				this.$("#crtLgInstTypeAuctionRadioLabel").html('Auction');		
				this.$("#crtLgInstTypeAuction").removeProp('disabled');
				this.$("#crtLgInstTypeAuctionRadio").removeClass('disabled');
			} else {
				if(this.$('input[name=lgType]:checked').val() == 'AUCTION'){
					this.$('input[name=lgType]').prop('checked', false);
				}
				
				this.$("#crtLgInstTypeAuctionRadioLabel").html('Auction (<a href="/draftapp/dashboard/purchase">Upgrade</a> to enable)');
				this.$("#crtLgInstTypeAuction").prop('disabled', 'disabled');
				this.$("#crtLgInstTypeAuctionRadio").addClass('disabled');
			}
			
			//Disable auction until it is built out
			if(!$(document).getUrlParam('auctionBeta')){
				this.$("#crtLgInstTypeAuctionRadio").hide();
			}
			
			this.displayBudget();
			
			$(this.el).find('.styled').uniform({radioClass: 'choice', selectAutoWidth: false});			
		},
		
		displayBudget: function() {
			if(this.$('input[name=lgType]:checked').val() == 'AUCTION'){
				this.$("#crtLgInstBudgetGrp").show();
			} else {
				this.$("#crtLgInstBudgetGrp").hide();
			}
		},
		
		addProdOption: function (container, product, prodDesc, checked) {
			var builtEl = $(this.prodTemplate({
				value: product.get('id'),
				checked: checked ? 'checked="checked"' : '',
				desc: prodDesc
			}));
			
			container.append(builtEl);
		},
		
		errorProduct : function (errorCode) {
			this.$("#crtLgInstProdGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#crtLgInstProdErrMsg").html("Product is empty");
					this.$("#crtLgInstProdErrMsg").show();
					break;
				default : 
					this.$("#crtLgInstProdErrMsg").html("Product is invalid");
					this.$("#crtLgInstProdErrMsg").show();
			}
		},
		
		errorType : function (errorCode) {
			this.$("#crtLgInstTypeGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#crtLgInstTypeErrMsg").html("Draft type is empty");
					this.$("#crtLgInstTypeErrMsg").show();
					break;
				default : 
					this.$("#crtLgInstTypeErrMsg").html("Draft type is invalid");
					this.$("#crtLgInstTypeErrMsg").show();
			}
		},
		
		errorNumTeams : function (errorCode) {
			this.$("#crtLgInstTeamsSelGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#crtLgInstTeamsSelErrMsg").html("Number of teams is empty");
					this.$("#crtLgInstTeamsSelErrMsg").show();
					break;
				default : 
					this.$("#crtLgInstTeamsSelErrMsg").html("Number of teams is invalid");
					this.$("#crtLgInstTeamsSelErrMsg").show();
			}
		},
		
		errorNumRounds : function (errorCode) {
			this.$("#crtLgInstRoundsSelGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#crtLgInstRoundsSelErrMsg").html("Number of rounds is empty");
					this.$("#crtLgInstRoundsSelErrMsg").show();
					break;
				default : 
					this.$("#crtLgInstRoundsSelErrMsg").html("Number of rounds is invalid");
					this.$("#crtLgInstRoundsSelErrMsg").show();
			}
		},
		
		errorBudget : function (errorCode) {
			this.$("#crtLgInstBudgetGrp").addClass("error");
			switch (errorCode){
				case "NULL": 
					this.$("#crtLgInstBudgetErrMsg").html("Budget is empty");
					this.$("#crtLgInstBudgetErrMsg").show();
					break;
				case "LENGTH":
					this.$("#crtLgInstBudgetErrMsg").html("Budget must be between 1 and 999");
					this.$("#crtLgInstBudgetErrMsg").show();
					break;
				case "NUMERIC":
					this.$("#crtLgInstBudgetErrMsg").html("Budget may only contain numeric characters");
					this.$("#crtLgInstBudgetErrMsg").show();
					break;
				default : 
					this.$("#crtLgInstBudgetErrMsg").html("Budget is invalid");
					this.$("#crtLgInstBudgetErrMsg").show();
			}
		},
	});

	var CreateLeagueMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			this.listenTo(Event, 'defaultCreate', this.hideAll);
			this.listenTo(Event, 'savingLgInst', this.processing);
			this.listenTo(Event, 'errorLgInst', this.error);
			this.listenTo(Event, 'success', this.success);
		},
		
		hideAll: function() {
			this.$("#crtLgBodyMessageError").hide();
			this.$("#crtLgBodyMessageProcessing").hide();
			this.$("#crtLgBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			this.$("#crtLgBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			this.$("#crtLgBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			this.$("#crtLgBodyMessageProcessing").show();
		},
	});
	
	var CreateLeagueView = Backbone.View.extend({
		el: $("#crtLgContent"),
		
		initialize: function(options) {
			this.prodCollection = options.prodCollection;
			this.userModel = options.userModel;
			this.userLeagueCollection = options.userLeagueCollection;
			this.prodConfigMap = options.prodConfigMap;
			this.crtLgModel = new CreateLeagueInstanceModel({});
			
			this.message = new CreateLeagueMessageView({el: this.$("#crtLgBodyMessage")});
			this.content = new CreateLeagueContentView({
					el: this.$("#crtLgBodyContent"),
					prodCollection: this.prodCollection,
					crtLgModel: this.crtLgModel,
					userModel: this.userModel,
					prodConfigMap: this.prodConfigMap
					});
			this.footer = new CreateLeagueFooterView({el: this.$("#crtLgFooter")});
			
			this.listenTo(this.crtLgModel, 'error', this.crtLgInstError);
			this.listenTo(this.crtLgModel, 'change', this.crtLgInstSuccess);
		},
		
		render: function () {
			Event.trigger("defaultCreate");
			
			return this;
		},
		
		crtLgInstError: function(model, error) {
			if (error.status == 400) {
				//Input errors
				Event.trigger("errorLgInst");
				
				var errObj = JSON.parse(error.responseText);
				
				if(errObj.code){
					for(var i=0; i< errObj.code.length; i++){
						if(errObj.code[i].indexOf("_") > 0){
							//Trigger a specific event for the field with the code attached as a param
							var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
							var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
							Event.trigger("errorLgInst:" + field.toLowerCase(), errCode);
						}
					}
				}
			/*} else if (error.status == 401 || error.status == 409) {
				//League name already taken
				Event.trigger("errorLgInst");
				Event.trigger("errorLgInst:leaguename", "LEAGUEEXISTS"); */
			} else {
				Event.trigger("errorLgInst");
			}
		},
		
		crtLgInstSuccess: function () {
			Event.trigger("success");
			this.userLeagueCollection.fetch();
		},
	});
	
	return CreateLeagueView;  
});